(function () {
  var EDIT_PARAM = 'tm_edit_line';
  var RETURN_PARAM = 'tm_return';
  var localeRoot = window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url;
  var DEFAULT_RETURN_URL = String(localeRoot || '/').replace(/\/?$/, '/') + 'pages/demande-de-devis';
  var PROPERTY_PATTERN = /^properties\[(.*)\]$/;
  var STUDIO_ARTWORK_PATTERN = /^(?:Studio artwork\s+|_tm_studio_artwork_)(\d+)$/i;
  var strings = readStrings();

  var params = new URLSearchParams(window.location.search);
  // The project editor owns V2 preparation and the saved-project revision.
  // Its form must never be intercepted by this legacy cart-only handler.
  if (params.has('tm_project_edit')) return;
  var editLineKey = params.get(EDIT_PARAM);
  if (window.__TODAYMERCH_QUOTE_LINE_EDITOR_TEST__) {
    window.TodayMerchQuoteLineEditorTest = {
      mergeForEdit: mergeForEdit,
      readStudioFileNames: readStudioFileNames,
    };
  }
  if (!editLineKey) return;

  var state = {
    form: null,
    line: null,
    lineKey: editLineKey,
    originalProperties: {},
    returnUrl: getSafeReturnUrl(params.get(RETURN_PARAM)),
    submitting: false,
  };

  function readStrings() {
    var script = document.querySelector('[data-quote-line-editor-strings]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('[Today Merch] Quote line editor translations are invalid.', error);
      return {};
    }
  }

  function string(key) {
    return String(strings[key] || '');
  }

  document.documentElement.classList.add('tm-quote-line-edit-pending');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  async function init() {
    state.form = findProductForm();
    if (!state.form) return;

    try {
      var cart = await fetchCart();
      var line = findCartLine(cart, state.lineKey);
      if (!line) {
        clearEditParams();
        document.documentElement.classList.remove('tm-quote-line-edit-pending');
        return;
      }

      state.line = line;
      state.originalProperties = normalizeProperties(line.properties);

      document.documentElement.classList.remove('tm-quote-line-edit-pending');
      document.documentElement.classList.add('tm-quote-line-edit');

      restoreLineBasics(line);
      restoreMarkingSelector(line);
      updateSubmitLabels();
      installSubmitHandler();
      installUrlPreserver();

      waitForStudio().then(function (studio) {
        restoreTodayStudio(studio, line);
      });
    } catch (error) {
      document.documentElement.classList.remove('tm-quote-line-edit-pending');
      console.warn('Quote line edit restore failed', error);
    }
  }

  function findProductForm() {
    return (
      document.querySelector('form[is="product-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getSafeReturnUrl(value) {
    if (!value) return DEFAULT_RETURN_URL;
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }
    } catch (error) {
      if (value.charAt(0) === '/' && value.slice(0, 2) !== '//') return value;
    }
    return DEFAULT_RETURN_URL;
  }

  function routeWithJs(routeName, fallback) {
    var route = window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes[routeName];
    var value = route || fallback;
    if (/\.js(?:\?|$)/.test(value)) return value;
    var hash = '';
    var query = '';
    var path = value;
    var hashIndex = path.indexOf('#');
    if (hashIndex >= 0) {
      hash = path.slice(hashIndex);
      path = path.slice(0, hashIndex);
    }
    var queryIndex = path.indexOf('?');
    if (queryIndex >= 0) {
      query = path.slice(queryIndex);
      path = path.slice(0, queryIndex);
    }
    return path.replace(/\/$/, '') + '.js' + query + hash;
  }

  function fetchCart() {
    return requestJson(routeWithJs('cart_url', '/cart'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
  }

  async function requestJson(url, options) {
    var response = await fetch(url, options);
    var text = await response.text();
    var json = null;

    try {
      json = text ? JSON.parse(text) : {};
    } catch (error) {
      json = null;
    }

    if (!response.ok || (json && json.status)) {
      var message = json && (json.description || json.message || json.errors);
      throw new Error(message || text || string('requestFailed'));
    }

    return json || {};
  }

  function postJson(url, payload) {
    return requestJson(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
  }

  function postFormData(url, formData) {
    return requestJson(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: formData,
    });
  }

  function findCartLine(cart, key) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.find(function (item) {
      return String(item.key || '') === String(key || '');
    }) || null;
  }

  function normalizeProperties(properties) {
    if (!properties || typeof properties !== 'object') return {};
    return Object.keys(properties).reduce(function (normalized, key) {
      var value = properties[key];
      if (value == null) return normalized;
      normalized[key] = String(value);
      return normalized;
    }, {});
  }

  function restoreLineBasics(line) {
    var form = state.form;
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && line.variant_id) {
      variantInput.value = String(line.variant_id);
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var quantity = Math.max(Number.parseInt(line.quantity, 10) || 1, 1);
    getNamedControls(form, 'quantity').forEach(function (input) {
      input.value = String(quantity);
      input.setAttribute('data-cart-quantity', '0');
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    preserveEditParams();
  }

  function updateSubmitLabels() {
    var labels = document.querySelectorAll('[data-role="quote-submit-label"], [data-studio-submit] span:first-child');
    labels.forEach(function (label) {
      label.textContent = string('submitLabel');
    });
  }

  function installSubmitHandler() {
    if (!state.form || state.form.dataset.quoteLineEditorBound === state.lineKey) return;
    state.form.addEventListener('submit', handleEditSubmit, true);
    state.form.dataset.quoteLineEditorBound = state.lineKey;
  }

  function installUrlPreserver() {
    document.addEventListener('variant:changed', function () {
      window.setTimeout(refreshEditContext, 0);
    });

    if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.subscribe) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(refreshEditContext, 0);
      });
    }
  }

  function refreshEditContext() {
    state.form = findProductForm() || state.form;
    if (!state.form) return;
    installSubmitHandler();
    updateSubmitLabels();
    getNamedControls(state.form, 'quantity').forEach(function (input) {
      input.setAttribute('data-cart-quantity', '0');
    });
    preserveEditParams();
  }

  function preserveEditParams() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(EDIT_PARAM, state.lineKey);
      url.searchParams.set(RETURN_PARAM, state.returnUrl);
      if (!url.searchParams.get('studio')) url.searchParams.set('studio', '1');
      window.history.replaceState(window.history.state || {}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // The edit state still works without URL preservation.
    }
  }

  function clearEditParams() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(EDIT_PARAM);
      url.searchParams.delete(RETURN_PARAM);
      url.searchParams.delete('studio');
      window.history.replaceState(window.history.state || {}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // Nothing to clean up if URL parsing is not available.
    }
  }

  function getNamedControls(form, name) {
    var controls = Array.from(form.querySelectorAll('[name="' + cssEscape(name) + '"]'));
    if (!form.id) return controls;

    return controls.concat(
      Array.from(document.querySelectorAll('[form="' + cssEscape(form.id) + '"][name="' + cssEscape(name) + '"]')).filter(function (control) {
        return control.form === form && !form.contains(control);
      })
    );
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(String(value));
    return String(value).replace(/([ #;?%&,.+*~':"!^$\[\]()=>|/@])/g, '\\$1');
  }

  function restoreMarkingSelector(line) {
    var selector = document.querySelector('product-marking-selector');
    if (!selector) return;

    var properties = state.originalProperties;
    var resolved = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
      ? window.TodayMerchLineItemProperties.resolve(properties)
      : null;
    var selectedKeys = resolved ? resolved.branding.zoneIds : splitList(properties._marking_zone_keys);
    var logoKeys = resolved ? resolved.branding.logoZoneIds : splitList(properties._marking_logo_zone_keys);
    var selectedLabels = splitList(properties.Personnalisation || properties.Personalization).map(normalizeText);
    var logoProperties = collectLogoProperties(properties);
    var wraps = Array.from(selector.querySelectorAll('[data-role="option-wrap"]'));

    wraps.forEach(function (wrap) {
      var input = wrap.querySelector('[data-role="marking-input"]');
      var zoneKey = String(wrap.dataset.zoneKey || input && input.dataset.zoneKey || '');
      var zoneLabel = String(wrap.dataset.zoneLabel || input && (input.dataset.zoneLabel || input.value) || '');
      var normalizedLabel = normalizeText(zoneLabel);
      var logoValue = logoProperties[normalizedLabel];
      var selected = selectedKeys.indexOf(zoneKey) >= 0 ||
        logoKeys.indexOf(zoneKey) >= 0 ||
        selectedLabels.indexOf(normalizedLabel) >= 0 ||
        Boolean(logoValue);

      if (input) input.checked = selected;

      if (logoValue) {
        var fileNames = splitFileNames(logoValue);
        delete wrap.dataset.logoCleared;
        wrap.dataset.logoFileName = fileNames[0] || getFileNameFromValue(logoValue);
        wrap.dataset.logoFileNames = JSON.stringify(fileNames.length ? fileNames : [wrap.dataset.logoFileName]);
        wrap.classList.add('has-logo-attached');
      } else if (!selected) {
        delete wrap.dataset.logoFileName;
        delete wrap.dataset.logoFileNames;
        wrap.classList.remove('has-logo-attached');
      }
    });

    if (typeof selector.storeCurrentVariantLogoState === 'function') selector.storeCurrentVariantLogoState();
    if (typeof selector.syncUI === 'function') selector.syncUI();
  }

  function collectLogoProperties(properties) {
    return Object.keys(properties).reduce(function (map, key) {
      if (key.indexOf('Logo - ') !== 0 || !properties[key]) return map;
      map[normalizeText(key.replace(/^Logo - /, ''))] = properties[key];
      return map;
    }, {});
  }

  function waitForStudio() {
    return new Promise(function (resolve) {
      var startedAt = Date.now();
      var timer = window.setInterval(function () {
        var root = document.querySelector('[data-todays-studio]');
        var studio = root && root._todaysStudio;
        if (studio || Date.now() - startedAt > 5000) {
          window.clearInterval(timer);
          resolve(studio || null);
        }
      }, 80);
    });
  }

  function restoreTodayStudio(studio, line) {
    if (!studio) return;

    var properties = state.originalProperties;
    if (!hasStudioProperties(properties)) return;

    try {
      if (typeof studio.resolveProductForm === 'function') studio.resolveProductForm();
      if (line.variant_id && typeof studio.selectVariant === 'function') studio.selectVariant(line.variant_id);

      var quantity = Math.max(Number.parseInt(line.quantity, 10) || 1, 1);
      if (studio.quantityInput) {
        studio.quantityInput.value = String(quantity);
        studio.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        studio.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof studio.syncQuantityToForm === 'function') studio.syncQuantityToForm();

      var resolved = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
        ? window.TodayMerchLineItemProperties.resolve(properties)
        : null;
      var transform = resolved ? resolved.studio.transform : parseJson(properties._studio_artwork_transform);
      var viewKey = resolved ? resolved.studio.viewId : (transform.viewId || properties._studio_view || transform.view || '');
      var zoneKey = resolved ? resolved.studio.zoneId : (transform.zoneId || transform.placementId || properties._studio_zone_key || transform.zone || '');

      if (typeof studio.resolveStudioSelection === 'function') {
        var resolvedSelection = studio.resolveStudioSelection(viewKey, zoneKey);
        viewKey = resolvedSelection && resolvedSelection.viewKey || viewKey;
        zoneKey = resolvedSelection && resolvedSelection.zoneKey || zoneKey;
      }

      if (viewKey && typeof studio.setActiveView === 'function') studio.setActiveView(viewKey);
      if (zoneKey && typeof studio.setActiveZone === 'function') studio.setActiveZone(zoneKey);

      var artworks = buildStudioArtworkItems(properties, transform);
      if (artworks.length) {
        hydrateStudioArtworks(studio, artworks);
      }

      if (params.get('studio') === '1' && typeof studio.open === 'function') {
        studio.open();
      }
    } catch (error) {
      console.warn('Today Studio edit restore failed', error);
    }
  }

  function hasStudioProperties(properties) {
    return Object.keys(properties).some(isStudioPropertyKey);
  }

  function isStudioPropertyKey(key) {
    return key === 'Studio Today Merch' ||
      key === 'Studio TodayMerch' ||
      key === 'Today Merch Studio' ||
      key === 'TodayMerch Studio' ||
      key.indexOf('Studio - ') === 0 ||
      key.indexOf('_studio_') === 0 ||
      key.indexOf('_tm_studio_') === 0 ||
      STUDIO_ARTWORK_PATTERN.test(key);
  }

  function buildStudioArtworkItems(properties, transform) {
    var artworkSources = collectStudioArtworkSources(properties);
    var transformArtworks = Array.isArray(transform.artworks) ? transform.artworks : [];

    if (transformArtworks.length) {
      return transformArtworks.map(function (artwork, index) {
        var source = artworkSources[index] || {};
        var fileName = artwork.fileName || source.fileName || string('designFallback');
        return normalizeStudioArtworkPayload(artwork, {
          fileName: fileName,
          previewUrl: source.previewUrl,
          originalType: source.originalType,
        }, transform.geometryVersion);
      });
    }

    if (artworkSources.length) {
      return artworkSources.map(function (source) {
        return normalizeStudioArtworkPayload({}, source, transform.geometryVersion);
      });
    }

    return readStudioFileNames(properties).map(function (fileName) {
      return normalizeStudioArtworkPayload({}, { fileName: fileName }, transform.geometryVersion);
    });
  }

  function collectStudioArtworkSources(properties) {
    return Object.keys(properties)
      .map(function (key) {
        var match = key.match(STUDIO_ARTWORK_PATTERN);
        if (!match || !properties[key]) return null;
        var value = properties[key];
        var fileName = getFileNameFromValue(value);
        var previewUrl = isImageLike(value) ? value : '';
        return {
          key: key,
          index: Number.parseInt(match[1], 10) || 0,
          value: value,
          fileName: fileName,
          previewUrl: previewUrl,
          originalType: previewUrl ? guessImageType(fileName || value) : '',
        };
      })
      .filter(Boolean)
      .sort(function (left, right) {
        return left.index - right.index;
      });
  }

  function normalizeStudioArtworkPayload(payload, fallback, geometryVersion) {
    fallback = fallback || {};
    var crop = payload.crop || {};
    return {
      fileName: String(payload.fileName || fallback.fileName || string('designFallback')),
      previewUrl: fallback.previewUrl || '',
      originalType: payload.type || fallback.originalType || '',
      x: toNumber(payload.x, 50),
      y: toNumber(payload.y, 50),
      width: toNumber(payload.width, 46),
      height: toNumber(payload.height, 20),
      rotation: toNumber(payload.rotation, 0),
      cropTop: toNumber(crop.top, 0),
      cropRight: toNumber(crop.right, 0),
      cropBottom: toNumber(crop.bottom, 0),
      cropLeft: toNumber(crop.left, 0),
      geometryVersion: toNumber(geometryVersion, 0),
    };
  }

  function hydrateStudioArtworks(studio, artworkItems) {
    if (typeof studio.clearArtwork === 'function') studio.clearArtwork();
    if (!Array.isArray(studio.artworks) || !studio.artworks.length) return;

    artworkItems.forEach(function (item, index) {
      var artwork = null;
      if (index === 0) {
        artwork = studio.artworks[0];
      } else if (typeof studio.createArtworkData === 'function') {
        artwork = studio.createArtworkData({});
        studio.artworks.push(artwork);
        if (typeof studio.createArtworkElement === 'function') studio.createArtworkElement(artwork);
      }

      if (!artwork) return;
      var normalizedItem = item;
      if (Number(item.geometryVersion || 0) < 2 && typeof studio.migrateLegacyArtworkGeometry === 'function') {
        normalizedItem = studio.migrateLegacyArtworkGeometry(item);
      }
      Object.assign(artwork, normalizedItem);
      paintStudioArtwork(studio, artwork, index);
    });

    var activeArtwork = studio.artworks.find(function (artwork) {
      return Boolean(artwork.fileName);
    });

    if (activeArtwork && typeof studio.setActiveArtwork === 'function') {
      studio.setActiveArtwork(activeArtwork.id, { selected: true });
    }

    studio.root && studio.root.classList.add('has-artwork');
    studio.root && studio.root.classList.remove('has-studio-error');
    studio.artworkCard && studio.artworkCard.classList.add('is-complete');

    if (typeof studio.updateArtworkStatus === 'function') studio.updateArtworkStatus();
    if (typeof studio.syncProperties === 'function') studio.syncProperties(true);
  }

  function paintStudioArtwork(studio, artwork, index) {
    if (typeof studio.setActiveArtwork === 'function') {
      studio.setActiveArtwork(artwork.id, { selected: index === 0 });
    }

    var element = studio.artworkElements && studio.artworkElements.get(artwork.id);
    if (!element) return;

    var image = element.querySelector('[data-studio-artwork-image]');
    var name = element.querySelector('[data-studio-artwork-name]');
    var hasImage = Boolean(artwork.previewUrl && isImageLike(artwork.previewUrl));

    if (image) {
      if (hasImage) {
        image.src = artwork.previewUrl;
        image.alt = artwork.fileName;
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.hidden = true;
      }
    }

    if (name) {
      name.textContent = hasImage ? '' : artwork.fileName;
      name.hidden = hasImage;
    }

    element.hidden = false;
    element.classList.toggle('is-file-only', !hasImage);

    if (typeof studio.updateArtwork === 'function') {
      studio.updateArtwork({ showGuides: false });
      Object.assign(artwork, studio.artwork);
      studio.artworks[index] = artwork;
    }
  }

  async function handleEditSubmit(event) {
    if (!state.line || state.submitting) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    state.submitting = true;
    setSubmitting(true);
    displayFormError(false);

    try {
      syncConfiguratorsBeforeSubmit();

      var formData = getFormData(state.form);
      var formProperties = extractProperties(formData);
      var mergedProperties = mergeProperties(formProperties.properties, formProperties.fileKeys);
      var variantId = String(formData.get('id') || state.line.variant_id || '');
      var quantity = getSubmitQuantity(formData);
      var variantChanged = variantId && String(state.line.variant_id || '') !== variantId;
      var needsReplacement = variantChanged || formProperties.fileKeys.size > 0;

      if (needsReplacement) {
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));
        applyMergedPropertiesToFormData(formData, mergedProperties, formProperties.fileKeys);

        await postFormData(routeWithJs('cart_add_url', '/cart/add'), formData);
        await postJson(routeWithJs('cart_change_url', '/cart/change'), {
          id: state.line.key,
          quantity: 0,
        });
      } else {
        await postJson(routeWithJs('cart_change_url', '/cart/change'), {
          id: state.line.key,
          quantity: quantity,
          properties: mergedProperties,
        });
      }

      window.location.href = state.returnUrl;
    } catch (error) {
      state.submitting = false;
      setSubmitting(false);
      displayFormError(error && error.message ? error.message : string('updateFailed'));
    }
  }

  function syncConfiguratorsBeforeSubmit() {
    var selector = document.querySelector('product-marking-selector');
    if (selector && typeof selector.syncUI === 'function') selector.syncUI();

    var studio = getStudioInstance();
    if (studio) {
      if (typeof studio.resolveProductForm === 'function') studio.resolveProductForm();
      if (typeof studio.syncQuantityToForm === 'function') studio.syncQuantityToForm();
      if (typeof studio.syncProperties === 'function') {
        studio.syncProperties(typeof studio.hasArtwork === 'function' ? studio.hasArtwork() : false);
      }
    }
  }

  function getStudioInstance() {
    var root = document.querySelector('[data-todays-studio]');
    return root && root._todaysStudio ? root._todaysStudio : null;
  }

  function getFormData(form) {
    var formData = new FormData(form);

    if (typeof form.syncAssociatedFormControls === 'function') {
      form.syncAssociatedFormControls(formData);
      return formData;
    }

    if (!form.id) return formData;

    var associatedControls = Array.from(document.querySelectorAll('[form="' + cssEscape(form.id) + '"]')).filter(function (control) {
      return control.form === form && !form.contains(control) && control.name;
    });

    associatedControls.forEach(function (control) {
      formData.delete(control.name);
    });

    associatedControls.forEach(function (control) {
      appendControlToFormData(formData, control);
    });

    return formData;
  }

  function appendControlToFormData(formData, control) {
    if (control.disabled || !control.name) return;
    var type = String(control.type || '').toLowerCase();

    if (type === 'file') {
      Array.from(control.files || []).forEach(function (file) {
        if (file && file.name) formData.append(control.name, file, file.name);
      });
      return;
    }

    if ((type === 'checkbox' || type === 'radio') && !control.checked) return;
    formData.append(control.name, control.value == null ? '' : control.value);
  }

  function extractProperties(formData) {
    var properties = {};
    var fileKeys = new Set();
    var presentKeys = new Set();

    Array.from(formData.entries()).forEach(function (entry) {
      var name = entry[0];
      var value = entry[1];
      var match = name.match(PROPERTY_PATTERN);
      if (!match) return;

      var key = match[1];
      presentKeys.add(key);

      if (isFileValue(value)) {
        if (value.name) fileKeys.add(key);
        return;
      }

      var stringValue = String(value == null ? '' : value).trim();
      if (stringValue && window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.isSafeMutationKey(key)) properties[key] = stringValue;
    });

    return { properties: properties, fileKeys: fileKeys, presentKeys: presentKeys };
  }

  function mergeProperties(submittedProperties, fileKeys) {
    var merged = mergeForEdit(state.originalProperties, submittedProperties, fileKeys, {
      markingPresent: Boolean(document.querySelector('product-marking-selector')),
      studioPresent: Boolean(document.querySelector('[data-todays-studio]')),
    });
    preserveExistingLogoProperties(merged, fileKeys);

    Object.keys(merged).forEach(function (key) {
      if (merged[key] == null || String(merged[key]).trim() === '') delete merged[key];
    });

    return merged;
  }

  function isMarkingPropertyKey(key) {
    return key === 'Personnalisation' ||
      key === 'Logo' ||
      key === 'Estimation marquage' ||
      key.indexOf('Logo - ') === 0 ||
      key.indexOf('_marking_') === 0 ||
      key.indexOf('_tm_branding_') === 0 ||
      key === '_tm_mockup_status';
  }

  function mergeForEdit(originalProperties, submittedProperties, fileKeys, options) {
    var original = normalizeProperties(originalProperties);
    var submitted = normalizeProperties(submittedProperties);
    var uploadedKeys = fileKeys instanceof Set ? fileKeys : new Set(fileKeys || []);
    var settings = options || {};
    var merged = Object.assign({}, original);

    if (settings.markingPresent) {
      Object.keys(merged).forEach(function (key) {
        if (isMarkingPropertyKey(key)) delete merged[key];
      });
    }

    if (settings.studioPresent) {
      var submittedNames = readStudioFileNames(submitted);
      var submittedArtworkKeys = Object.keys(submitted).filter(function (key) {
        return /^_tm_studio_artwork_\d+$/i.test(key);
      });
      var hasUploadedArtwork = Array.from(uploadedKeys).some(function (key) {
        return /^_tm_studio_artwork_\d+$/i.test(key);
      });
      var preserveLegacyUrls = submittedNames.length > 0 && !submittedArtworkKeys.length && !hasUploadedArtwork;

      Object.keys(merged).forEach(function (key) {
        if (!isStudioPropertyKey(key)) return;
        if (preserveLegacyUrls && /^Studio artwork\s+\d+$/i.test(key)) return;
        delete merged[key];
      });
    }

    Object.assign(merged, submitted);
    if (window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.materializeCanonical) {
      merged = window.TodayMerchLineItemProperties.materializeCanonical(merged, submitted);
    }
    Object.keys(merged).forEach(function (key) {
      if (merged[key] == null || String(merged[key]).trim() === '') delete merged[key];
    });
    return merged;
  }

  function preserveExistingLogoProperties(merged, fileKeys) {
    var selector = document.querySelector('product-marking-selector');
    if (!selector) return;

    var activeLogoLabels = new Set();
    Array.from(selector.querySelectorAll('[data-role="option-wrap"]')).forEach(function (wrap) {
      var input = wrap.querySelector('[data-role="marking-input"]');
      var zoneLabel = String(wrap.dataset.zoneLabel || input && (input.dataset.zoneLabel || input.value) || '');
      var fileNames = typeof selector.getLogoFileNames === 'function' ? selector.getLogoFileNames(wrap) : splitFileNames(wrap.dataset.logoFileNames || wrap.dataset.logoFileName);
      if (input && input.checked && fileNames.length) {
        activeLogoLabels.add(normalizeText(zoneLabel));
      }
    });

    Object.keys(state.originalProperties).forEach(function (key) {
      if (key.indexOf('Logo - ') !== 0 || fileKeys.has(key)) return;
      var label = normalizeText(key.replace(/^Logo - /, ''));
      if (activeLogoLabels.has(label)) merged[key] = state.originalProperties[key];
    });
  }

  function preserveExistingStudioArtworkProperties(merged, submittedProperties, fileKeys) {
    var studio = getStudioInstance();
    var hasArtwork = studio && typeof studio.hasArtwork === 'function' ? studio.hasArtwork() : Boolean(submittedProperties._studio_artwork_transform);
    if (!hasArtwork) return;

    var activeNames = getActiveStudioFileNameSet(submittedProperties, studio);
    Object.keys(state.originalProperties).forEach(function (key) {
      if (!STUDIO_ARTWORK_PATTERN.test(key) || fileKeys.has(key)) return;
      var oldName = normalizeText(getFileNameFromValue(state.originalProperties[key]));
      if (!activeNames.size || activeNames.has(oldName)) {
        merged[key] = state.originalProperties[key];
      }
    });
  }

  function getActiveStudioFileNameSet(submittedProperties, studio) {
    var names = readStudioFileNames(submittedProperties);
    var transform = parseJson(submittedProperties._tm_studio_transform || submittedProperties._studio_artwork_transform);
    if (!names.length && Array.isArray(transform.artworks)) {
      names = transform.artworks.map(function (artwork) {
        return artwork && artwork.fileName;
      }).filter(Boolean);
    }
    if (!names.length && studio && Array.isArray(studio.artworks)) {
      names = studio.artworks.map(function (artwork) {
        return artwork && artwork.fileName;
      }).filter(Boolean);
    }
    return new Set(names.map(function (name) {
      return normalizeText(name);
    }));
  }

  function applyMergedPropertiesToFormData(formData, mergedProperties, fileKeys) {
    Object.keys(mergedProperties).forEach(function (key) {
      if (fileKeys.has(key)) return;
      var name = window.TodayMerchLineItemProperties && (window.TodayMerchLineItemProperties.isSafeMutationKey(key) || window.TodayMerchLineItemProperties.isPreservedLegacyFileUrl(key, mergedProperties[key])) ? 'properties[' + key + ']' : '';
      if (!name) return;
      formData.delete(name);
      formData.append(name, mergedProperties[key]);
    });
  }

  function getSubmitQuantity(formData) {
    var quantity = Number.parseInt(formData.get('quantity'), 10);
    if (!Number.isFinite(quantity) || quantity <= 0) {
      quantity = Number.parseInt(state.line.quantity, 10) || 1;
    }
    return Math.max(quantity, 1);
  }

  function setSubmitting(isSubmitting) {
    var buttons = Array.from(document.querySelectorAll('[data-role="quote-submit"], [data-studio-submit]'));
    buttons.forEach(function (button) {
      if (isSubmitting) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
      button.classList.toggle('btn--loading', isSubmitting);
      button.classList.toggle('is-loading', isSubmitting);
    });
  }

  function displayFormError(message) {
    if (typeof state.form.displayFormErrors === 'function') {
      state.form.displayFormErrors(message);
      return;
    }

    var errorMessage = state.form.querySelector('.product-form__error-message');
    if (!errorMessage) {
      if (message) alert(message);
      return;
    }

    errorMessage.toggleAttribute('hidden', !message);
    if (message) errorMessage.textContent = message;
  }

  function splitList(value) {
    return String(value || '')
      .split(',')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function splitFileNames(value) {
    var raw = String(value || '').trim();
    if (!raw) return [];

    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map(function (item) {
          return getFileNameFromValue(item);
        }).filter(Boolean);
      }
    } catch (error) {
      // Plain filenames and URLs are expected most of the time.
    }

    return raw
      .split(/\s*[·,]\s*/)
      .map(getFileNameFromValue)
      .filter(Boolean);
  }

  function readStudioFileNames(properties) {
    var resolved = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
      ? window.TodayMerchLineItemProperties.resolve(properties || {})
      : null;
    if (resolved && resolved.studio.fileNames.length) return resolved.studio.fileNames.slice();
    return splitFileNames((properties || {})._tm_studio_artwork_file_names ||
      (properties || {})._studio_artwork_file_name ||
      (properties || {})['Studio - Fichier'] ||
      (properties || {})['Studio - File']);
  }

  function getFileNameFromValue(value) {
    var text = String(value || '').trim();
    if (!text) return '';

    try {
      var url = new URL(text, window.location.origin);
      var segments = url.pathname.split('/').filter(Boolean);
      return decodeURIComponent(segments.pop() || text);
    } catch (error) {
      return text.split(/[\\/]/).pop().split('?')[0].split('#')[0].trim();
    }
  }

  function isImageLike(value) {
    var text = String(value || '');
    return /^data:image\//i.test(text) || /\.(png|jpe?g|webp|gif|svg|avif)(?:\?|#|$)/i.test(text);
  }

  function guessImageType(value) {
    var extension = String(value || '').split('?')[0].split('#')[0].split('.').pop().toLowerCase();
    if (!extension || extension === value) return '';
    if (extension === 'jpg') extension = 'jpeg';
    if (['jpeg', 'png', 'webp', 'gif', 'svg', 'avif'].indexOf(extension) >= 0) {
      return extension === 'svg' ? 'image/svg+xml' : 'image/' + extension;
    }
    return '';
  }

  function parseJson(value) {
    if (!value) return {};
    try {
      var parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .replace(/_+/g, '_');
  }

  function isFileValue(value) {
    return typeof File !== 'undefined' && value instanceof File;
  }
})();
